if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}


/* Penguen navigable product lightbox */
(() => {
  const directMedia = (modal) => [...modal.querySelectorAll('.product-media-modal__content > [data-media-id]')];

  const enhanceModal = (modal) => {
    if (!modal || modal.dataset.pgnLightboxReady === 'true') return;
    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    const items = directMedia(modal);
    if (!dialog || !content || !items.length) return;

    modal.dataset.pgnLightboxReady = 'true';

    const nav = document.createElement('div');
    nav.className = 'pgn-media-lightbox__nav';
    nav.setAttribute('aria-label', 'Medya gezinme kontrolleri');
    nav.innerHTML =
      '<button type="button" class="pgn-media-lightbox__arrow pgn-media-lightbox__arrow--prev" aria-label="Önceki medya">‹</button>' +
      '<button type="button" class="pgn-media-lightbox__arrow pgn-media-lightbox__arrow--next" aria-label="Sonraki medya">›</button>';

    const dock = document.createElement('div');
    dock.className = 'pgn-media-lightbox__dock';
    dock.innerHTML = '<span class="pgn-media-lightbox__count" aria-live="polite"></span><div class="pgn-media-lightbox__thumbs" role="list"></div>';

    const rail = dock.querySelector('.pgn-media-lightbox__thumbs');
    const count = dock.querySelector('.pgn-media-lightbox__count');

    items.forEach((item, index) => {
      item.dataset.pgnLightboxIndex = String(index);
      const source = item.matches('img') ? item : item.querySelector('img');
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'pgn-media-lightbox__thumb';
      thumb.dataset.index = String(index);
      thumb.setAttribute('role', 'listitem');
      thumb.setAttribute('aria-label', (source?.alt || 'Ürün medyası') + ' ' + (index + 1));
      if (source) {
        const image = document.createElement('img');
        const sourceUrl = source.currentSrc || source.getAttribute('src') || '';
        image.src = sourceUrl.replace(/([?&])width=\d+/i, '$1width=160');
        image.alt = '';
        image.loading = 'lazy';
        thumb.appendChild(image);
      }
      rail.appendChild(thumb);
    });

    const showIndex = (requestedIndex, focusThumb = false) => {
      const currentItems = directMedia(modal);
      if (!currentItems.length) return;
      const index = (requestedIndex + currentItems.length) % currentItems.length;
      [index, (index + 1) % currentItems.length, (index - 1 + currentItems.length) % currentItems.length].forEach((warmIndex) => {
        const warmItem = currentItems[warmIndex];
        const warmImage = warmItem?.matches('img') ? warmItem : warmItem?.querySelector('img');
        if (warmImage) warmImage.loading = 'eager';
      });
      currentItems.forEach((item, itemIndex) => item.classList.toggle('active', itemIndex === index));
      modal.dataset.pgnLightboxIndex = String(index);
      count.textContent = (index + 1) + ' / ' + currentItems.length;
      rail.querySelectorAll('.pgn-media-lightbox__thumb').forEach((thumb, thumbIndex) => {
        if (thumbIndex === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const activeThumb = rail.querySelector('.pgn-media-lightbox__thumb[aria-current="true"]');
      activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      content.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      if (focusThumb) activeThumb?.focus();
    };

    modal._pgnShowLightboxIndex = showIndex;

    nav.querySelector('.pgn-media-lightbox__arrow--prev').addEventListener('click', () => {
      showIndex((Number(modal.dataset.pgnLightboxIndex) || 0) - 1);
    });
    nav.querySelector('.pgn-media-lightbox__arrow--next').addEventListener('click', () => {
      showIndex((Number(modal.dataset.pgnLightboxIndex) || 0) + 1);
    });
    rail.addEventListener('click', (event) => {
      const thumb = event.target.closest('.pgn-media-lightbox__thumb');
      if (thumb) showIndex(Number(thumb.dataset.index));
    });
    [nav, dock].forEach((control) => control.addEventListener('pointerup', (event) => event.stopPropagation()));

    modal.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showIndex((Number(modal.dataset.pgnLightboxIndex) || 0) - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showIndex((Number(modal.dataset.pgnLightboxIndex) || 0) + 1);
      }
    });

    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      const activeIndex = directMedia(modal).findIndex((item) => item.classList.contains('active'));
      showIndex(activeIndex >= 0 ? activeIndex : 0);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    dialog.append(nav, dock);
  };

  const enhanceAll = () => document.querySelectorAll('product-modal').forEach(enhanceModal);

  document.addEventListener('click', (event) => {
    const image = event.target.closest('.pgn-pdp-surface .product__media-item.is-active .product__media img');
    if (!image || image.closest('quick-add-modal') || image.closest('product-modal')) return;
    const opener = image.closest('modal-opener');
    const button = opener?.querySelector('.product__media-toggle');
    const modal = opener ? document.querySelector(opener.getAttribute('data-modal')) : null;
    if (!button || !modal) return;
    event.preventDefault();
    enhanceModal(modal);
    button.click();
  });

  document.addEventListener('shopify:section:load', enhanceAll);
  enhanceAll();
})();
